/* eslint-disable no-restricted-globals */
import { useState, useContext } from "react"
import { useNavigate } from "react-router-dom"
import _ from "lodash"
import axios from "axios"

import { Dialog } from "primereact/dialog"
import { Button } from "primereact/button"

// Context
import { UserContext } from "../../../context/userContext"

// Services
import { gpraUrl } from "../../../config/microservicesUrls"
import { endpoints } from "../../../config/gpraApiEndpoints"

export default function GPRADischargeDialog({
  visible,
  ableToDelete,
  gpraRecordId,
  dischargeCompleted,
}) {
  const navigate = useNavigate()
  const [showDialog, setShowDialog] = useState(visible)
  const userCtx = useContext(UserContext)

  function handleButtonClick() {
    setShowDialog(false)
  }

  return (
    <Dialog
      header="GPRA discharge is required"
      visible={showDialog}
      style={{ width: "50vw" }}
      onHide={() => navigate("/participant/gpra-forms")}
      closable={false}
    >
      <div style={{ textAlign: "center" }}>
        <p>
          The current Participant is{" "}
          <strong>actively enrolled in a GPRA program.</strong>
        </p>
        <p>
          GPRA discharge interview must be completed prior to service discharge.
        </p>
        <div
          style={{
            display: "flex",
            gap: 10,
            justifyContent: "center",
            margin: "30px 0",
          }}
        >
          <Button onClick={() => navigate("/participant/profile")}>
            Return to profile
          </Button>
          {ableToDelete === false && dischargeCompleted === false && (
            <Button onClick={() => navigate("/participant/gpra-forms")}>
              Complete GPRA Discharge
            </Button>
          )}
          {ableToDelete === true && (
            <Button
              onClick={async () => {
                try {
                  await axios.post(
                    `${gpraUrl()}${endpoints.DELETE_GPRA_RECORD}`,
                    { gpra_record_id: gpraRecordId },
                    {
                      headers: {
                        Authorization: "Bearer " + userCtx.tokenGpra,
                      },
                    }
                  )
                  handleButtonClick()
                } catch (error) {
                  handleButtonClick()
                }
              }}
            >
              Delete empty GPRA Record and Discharge
            </Button>
          )}
        </div>
      </div>
    </Dialog>
  )
}
